export default __webpack_public_path__ + "static/media/magal.72fe690b.jpg";